import 'magnific-popup';
import 'slick-carousel';

'use strict';

$(() => {

  const setMyConditionsPopupOpenEvent = () => {
    const $myconditions = $('.myconditions_inline_link');

    $myconditions.click(e => {
      const popupId = $(e.target).data('id');

      $.ajax({
        url: '/popup/' + popupId,
        type: 'POST',
      }).done(data => {
        $('#popup_' + popupId).html(data);
        popupOpen(popupId);
      }).fail(data => {
        $myconditions.magnificPopup('close');
        alert('エラーが発生しました。');
      });
    });
  };

  const popupOpen = popupId => {
    $.magnificPopup.open({
      items: {src: '#popup_' + popupId},
      type: 'inline',
      fixedContentPos: true,
    }, 0);
  };

  setMyConditionsPopupOpenEvent();
});